import { useMutation } from '@tanstack/react-query';
import { Button } from '@givebutter/primitives/button';
import { useToast } from '@givebutter/primitives/toast';
import { faRefresh } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';
import { queryClient } from 'queries/queryClient';
import { GivebutterAxiosError } from 'types/error';

const PayoutsRefreshButton = () => {
    const { accountId } = useCurrentAccount();
    const { success, error } = useToast();

    const { mutate: refreshPayouts, isPending: isRefreshing } = useMutation({
        mutationFn: async () => {
            await queryClient.invalidateQueries({
                queryKey: accountQueryKeys.campaignPayouts(accountId),
                type: 'all',
            });
        },
        onSuccess: () => {
            success('Payouts data refreshed successfully!', { duration: 1000 });
        },
        onError: (e: GivebutterAxiosError) => {
            error(e.response?.data?.message ?? 'Failed to refresh payouts data.');
        },
    });

    return (
        <Button variant="solid" onClick={() => refreshPayouts()} disabled={isRefreshing}>
            <FontAwesomeIcon icon={faRefresh} className={isRefreshing ? 'animate-spin' : ''} />
            Refresh
        </Button>
    );
};

export { PayoutsRefreshButton };
